module.exports = __webpack_public_path__ + "static/img/thinkstep-anz_logo_2.371221c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thinkstep-anz_logo_2.png
// module id = fzTT
// module chunks = 1